const u = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1600&q=70`;

export const CITY_META = {
  dubai: { photo: u("photo-1512453979798-5ea266f8880c"), alt: "Burj Khalifa above Dubai's skyline", accent: "#B45309", soft: "#FEF3C7" },
  singapore: { photo: u("photo-1620033263019-f2ec2c738a60"), alt: "Marina Bay, Singapore", accent: "#047857", soft: "#D1FAE5" },
  london: { photo: u("photo-1513635269975-59663e0ac1ad"), alt: "Tower Bridge and the Thames, London", accent: "#1E3A8A", soft: "#DBEAFE" },
  "new-york": { photo: u("photo-1518235506717-e1ed3306a89b"), alt: "Manhattan skyline across the Hudson", accent: "#BE123C", soft: "#FFE4E6" },
  "hong-kong": { photo: u("photo-1690070767302-86a0f719a36f"), alt: "Victoria Harbour, Hong Kong", accent: "#6D28D9", soft: "#EDE9FE" },
  oxford: { photo: u("photo-1612563958093-2c3bcfbd8760"), alt: "Radcliffe Camera and the colleges of Oxford", accent: "#4338CA", soft: "#E0E7FF" },
  barcelona: { photo: u("photo-1578095172812-dcc191c5aed8"), alt: "Sagrada Família above Barcelona at golden hour", accent: "#C2410C", soft: "#FFEDD5" },
  "abu-dhabi": { photo: u("photo-1512632578888-169bbbc64f33"), alt: "Sheikh Zayed Grand Mosque, Abu Dhabi", accent: "#0369A1", soft: "#E0F2FE" },
  sydney: { photo: u("photo-1620361189480-1131ceef5ec0"), alt: "Sydney Opera House on the harbour", accent: "#0E7490", soft: "#CFFAFE" },
};
export const FALLBACK_META = { photo: null, alt: "", accent: "#002147", soft: "#E7E5E4" };
export const metaFor = (c) => {
  const m = CITY_META[c.slug];
  return m || { ...FALLBACK_META, photo: c.photo_url || null, alt: c.name };
};

const LABELS = {
  sports_participate: "Sport (play)", sports_watch: "Sport (watch)", live_music: "Live music",
  content_creation: "Content creation", diverse: "Diversity", cafe: "Cafés", green: "Green space",
};
export const label = (tag) => LABELS[tag] || tag.charAt(0).toUpperCase() + tag.slice(1).replace(/_/g, " ");

export const compact = (n) => {
  if (n == null) return "—";
  if (n >= 1e6) return `${(n / 1e6).toFixed(1).replace(/\.0$/, "")}M`;
  if (n >= 1e3) return `${Math.round(n / 1e3)}k`;
  return String(n);
};

export const slugTestId = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
